import { forwardRef } from 'react'
import type { TextareaHTMLAttributes } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid = false, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={classNames(styles.textarea, className, { [styles.invalid]: invalid })}
      aria-invalid={invalid}
      {...rest}
    />
  ),
)

Textarea.displayName = 'Textarea'

export default Textarea
